/// <reference path="../../../../Scripts/typings/q/q.d.ts" />
/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/shopitemtemplate/viewmodels/edit',["require", "exports", "services/trace", "areas/shopitemtemplate/services/mappings", "areas/shopitemtemplate/services/shopitemtemplaterepository", "areas/shopitemtemplate/commands/createshopitemscommand", "common/viewmodelbase", "services/navigator"], function (require, exports, Trace, Mapping, Repository, CreateShopItemsCommand, common, navigator) {
    "use strict";
    var ShopItemTemplateViewModel = (function (_super) {
        __extends(ShopItemTemplateViewModel, _super);
        function ShopItemTemplateViewModel() {
            _super.call(this);
            this.optionValues = ["keine", "alle", "EinStb"];
            this.selectedOptionValue = "keine";
            this.closeButtonText = " Abbrechen";
            ko.track(this, ["template", "selectedOptionValue", "optionValues", "closeButtonText"]);
        }
        // #endregion
        ShopItemTemplateViewModel.prototype.onActivated = function (context) {
            var that = this;
            this.initialize();
            var workStatus = $.t("app:modules.shopitemtemplate.message_loadShopItemTemplate", { ifMissing: "ShopItemTemplate wird geladen..." });
            return this.taskManager.startAsync(workStatus, function () {
                return that.readShopItemTemplateAsync(context.queryString.memberType, context.queryString.id)
                    .then(function (data) {
                    that.template = data;
                });
            });
        };
        ShopItemTemplateViewModel.prototype.initialize = function () {
            this.setUpController();
            this.attachEvents();
            this.createShopItemsCommand = new CreateShopItemsCommand();
        };
        ShopItemTemplateViewModel.prototype.attachEvents = function () {
            //ko.getObservable(this, "name").subscribe(value => {
            //    this.controller.filterDefinitions.replace(Data.BreezeColumnFilter.contains("Name", value));
            //});
        };
        ShopItemTemplateViewModel.prototype.setUpController = function () {
        };
        ShopItemTemplateViewModel.prototype.update = function () {
            var _this = this;
            var workStatus = $.t("app:modules.shopitemtemplate.message_saveShopItemTemplate", { ifMissing: "ShopItemTemplate wird gespeichert..." });
            this.taskManager.startAsync(workStatus, function () {
                var repository = new Repository.ShopItemTemplateRepository();
                return repository.update(_this.template)
                    .then(function (data) {
                    navigator.goBack();
                }).fail(function (exception) {
                    var errorMessage = $.t("app:modules.shopitemtemplate.message_saveShopItemTemplateFailure", { ifMissing: "Fehler beim Speichern des ShopItemTemplates: " });
                    Trace.traceError(errorMessage + exception.responseText, null, "shopitemtemplate", true);
                });
            });
        };
        ShopItemTemplateViewModel.prototype.cancel = function () {
            navigator.goBack();
        };
        ShopItemTemplateViewModel.prototype.readShopItemTemplateAsync = function (memberType, id) {
            var repository = new Repository.ShopItemTemplateRepository();
            return repository.read(memberType, id)
                .then(function (data) {
                return Mapping.mapShopItemTemplateFromDTO(data);
                ;
            }).fail(function (error) {
                return null;
            });
        };
        return ShopItemTemplateViewModel;
    }(common.ViewModelBase));
    return ShopItemTemplateViewModel;
});

